import axios from 'axios'
import library from '../../../utils/Library'

export const createUserSystemDefined = async (body) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('storage') + '/directory/createUserSystemDefined'

  return await axios({
    url: URL,
    method: 'POST',
    data: body,
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
